import { Component, OnInit, HostListener } from '@angular/core';

@Component({
  selector: 'app-shorts',
  templateUrl: './shorts.component.html',
  styleUrls: ['./shorts.component.css']
})
export class ShortsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

  @HostListener('window:message', ['$event'])
  onMessage(event: MessageEvent) {
    if (event.data?.type === 'PROMO_CLICK') {
      // WebEngage Promo Click removed (off allowlist)
    }
  }
}
